export default "__VITE_ASSET__bdc3be8e__"